import React, { useState } from "react"
import Container from "react-bootstrap/Container"
import Button from "react-bootstrap/Button"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Logo from "../common/Logo"
import PhoneIcon from "../../assets/Icons/svgs/phone.svg"
import { FaBars } from "react-icons/fa"
import TopNavMenu from "./TopNavMenu"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import SearchBox from "../common/SearchBox"

export default function TopNavbar({ navmenus, widget, postLinks }) {
  const [expanded, setExpanded] = useState(false)

  function handleClick(e) {
    console.log(`CALL US NOW`)
    e.preventDefault()
    trackCustomEvent({
      category: "CTA buttons",
      action: "Click",
      label: "Header CTA",
    })
    window.open("tel:+18887673708")
  }

  return (
    <Navbar bg="transparent" expand="lg" expanded={expanded}>
      <Container>
        <Navbar.Brand href="/">
          <Logo />
        </Navbar.Brand>
        <Navbar.Collapse id="top-navbar-nav">
          <Nav className="me-auto">
            {navmenus.map(menu => (
              <TopNavMenu
                key={menu.key}
                item={menu}
                setExpanded={setExpanded}
              />
            ))}
          </Nav>
        </Navbar.Collapse>
        <SearchBox postLinks={postLinks} className="search search--default" />
        <Button
          variant="warning"
          onClick={handleClick}
        >
          <PhoneIcon />
          <span>CALL US NOW</span>
        </Button>
        <Navbar.Toggle
          as="div"
          aria-controls="top-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        >
          <FaBars />
        </Navbar.Toggle>

      </Container>
      <SearchBox postLinks={postLinks} className="search search--mobile" />

    </Navbar>
  )
}
